import { TableColumn } from '@cubejs-client/core';

const flatten = (columns: TableColumn[] = []): any => {
  return columns.reduce((memo, column) => {
    if (column.children) {
      return [...memo, ...flatten(column.children)];
    }
    return [...memo, column];
  }, [] as TableColumn[]);
};
const formatValue = (value: any, { type, format }: any = {}) => {
  if (value === undefined) {
    return value;
  }
  if (type === 'boolean') {
    if (typeof value === 'boolean') {
      return value.toString();
    } else if (typeof value === 'number') {
      return Boolean(value).toString();
    }
    return value;
  }
  if (type === 'number' && format === 'percent') {
    return [parseFloat(value).toFixed(2), '%'].join('');
  }
  return value.toString();
};

export const formatTableData = (columns: TableColumn[], data: any[]) => {
  const typeByIndex = flatten(columns).reduce((memo: any, column: any) => {
    return { ...memo, [column.dataIndex]: column };
  }, {});
  return data.map((row: any) => {
    const item = Object.fromEntries(
      Object.entries(row).map(([dataIndex, value]) => {
        return [dataIndex, formatValue(value, typeByIndex[dataIndex])];
      }),
    );
    return item;
  });
};
